import { style } from '@vanilla-extract/css'

const notification = style({
  position: 'fixed',
  bottom: '1rem',
  width: 'max-content',
  maxWidth: '90%',
  left: '50%',
  fontSize: '14px',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem 1.5rem',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  backdropFilter: 'blur(3px)',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08), 0px 8px 12px rgba(0, 0, 0, 0.16)',
  transition: 'opacity 0.15s ease',
  pointerEvents: 'none',
  zIndex: 2147480002,
})

const text = style({
  color: 'white',
})

export const styles = {
  notification,
  text,
}
